const getters = {
  token: state => state.user.token,
  userID: state => state.user.userID,
  username: state => state.user.username,
  userRole: state => state.user.userRole,
  lastLoginTime: state => state.user.lastLoginTime
};
export default getters;